import { Component, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { Utils } from 'src/app/shared/utils';
import { NgClass, NgIf } from '@angular/common';
import { HeartHeaderComponent } from '../../../../../../../shared/lista-deseos/heart-header/heart-header.component';

@Component({
    selector: 'app-rebeccaadventuretravel',
    templateUrl: './rebeccaadventuretravel.component.html',
    styleUrls: ['./rebeccaadventuretravel.component.scss'],
    imports: [NgClass, NgIf, HeartHeaderComponent]
})
export class RebeccaadventuretravelComponent implements OnInit {

  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @ViewChild('header') headerRef!: ElementRef;

  constructor(
    public companyParamsService: CompanyParamsService
  ) { }
  showMenu: boolean = false;

  ngOnInit(): void {
  }

  renderMenu() {
    this.showMenu = !this.showMenu;
  }

  goFavorites() {
    const urlFavorites: any =
      this.companyParamsService.getNameUrl() +
      '/wishlist';
    Utils.openNewTab(urlFavorites);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      var height = this.headerRef.nativeElement.offsetHeight;
      this.headerHeight.emit(height);
    }, 300);
  }

}
